export * from "./image-template.component";
